import {Injectable} from '@angular/core';
import {ApiService} from "./api.service";
import {Configuration} from "../class/config/configuration";

@Injectable({
  providedIn: 'root'
})
export class WelfyConfigService {

  private configuration: Configuration;

  constructor(private apiService: ApiService) {
    this.initService();
  }

  private initService(){
    this.apiService.getFrontedConfiguration().subscribe(value => {
      this.configuration = value;
    })
  }

  get config(){
    return this.configuration;
  }


}
